import { generateUID } from '@/utils/utils';
import { WatchOptions } from 'vue';
import { createDecorator } from 'vue-class-component';
import get from 'lodash/get';

const getCircularObjectReplacer = () => {
  const seen = new WeakSet();

  return (key: string, value: unknown) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return '[Circular]';
      }
      seen.add(value);
    }
    return value;
  };
};

export function WatchObjectAsJson(path: string, watchOptions: Omit<WatchOptions, 'deep'> = {}) {
  return createDecorator((componentOptions, handler) => {
    // Create a component computed property, which transforms the object
    componentOptions.computed = componentOptions.computed || Object.create(null);
    const computed = componentOptions.computed!;
    const uid = generateUID().replace(/-/g, '_');
    const computedName = `__WatchObjectAsJson_${path.replace(/\./g, '_')}_${uid}`;

    computed[computedName] = function() {
      return JSON.stringify(get(this, path), getCircularObjectReplacer());
    };

    componentOptions.watch = componentOptions.watch || Object.create(null);
    // Watch the created computed property
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (componentOptions.watch![computedName] as any) = { handler, ...watchOptions };
  });
}
